import { Controller } from "@hotwired/stimulus"

// Colour theme switcher: light / system / dark. Persists to localStorage and
// stamps data-theme on <html> (the no-flash bootstrap in the layout reads it
// on first paint). System (auto) is the default; explicit light/dark override.
export default class extends Controller {
  static targets = ["btn"]

  connect() {
    this.mq = window.matchMedia("(prefers-color-scheme: dark)")
    this.mqListener = () => { if (this.current === "system") this.apply("system") }
    this.mq.addEventListener("change", this.mqListener)
    this.apply(this.current)
    this.sync()
  }

  disconnect() {
    this.mq.removeEventListener("change", this.mqListener)
  }

  get current() {
    try { return localStorage.getItem("ghafah-theme") || "system" } catch (e) { return "system" }
  }

  set current(v) {
    try { localStorage.setItem("ghafah-theme", v) } catch (e) {}
  }

  setLight()  { this.choose("light") }
  setSystem() { this.choose("system") }
  setDark()   { this.choose("dark") }

  choose(v) { this.current = v; this.apply(v); this.sync() }

  apply(v) {
    const resolved = v === "system" ? (this.mq.matches ? "dark" : "light") : v
    document.documentElement.dataset.theme = resolved
  }

  sync() {
    const cur = this.current
    this.btnTargets.forEach((b) =>
      b.setAttribute("aria-pressed", String(b.dataset.themeName === cur))
    )
  }
}
